"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WebServerBase_1 = require("./base/WebServerBase");
var WebServerCustomer_1 = require("./customer/WebServerCustomer");
var ControllerToDo_1 = require("./todo/ControllerToDo");
var ControllerWebClient_1 = require("./webclient/ControllerWebClient");
var ControllerAutocomplete_1 = require("./autocomplete/ControllerAutocomplete");
var ControllerEvent_1 = require("./event/ControllerEvent");
var defaultPort = 9021;
var WebServerProxy = /** @class */ (function () {
    function WebServerProxy(options) {
        if (options.port === undefined) {
            options.port = 9021;
        }
        this._webServerBase = new WebServerBase_1.WebServerBase(options);
    }
    Object.defineProperty(WebServerProxy.prototype, "webServerBase", {
        get: function () {
            return this._webServerBase;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebServerProxy.prototype, "webServersCustomer", {
        get: function () {
            if (this._webServersCustomer === undefined) {
                this._webServersCustomer = new WebServerCustomer_1.WebServerCustomer(this.webServerBase);
            }
            return this._webServersCustomer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebServerProxy.prototype, "ToDo", {
        get: function () {
            if (this._controllerToDo === undefined) {
                this._controllerToDo = new ControllerToDo_1.ControllerToDo(this.webServerBase);
            }
            return this._controllerToDo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebServerProxy.prototype, "WebClient", {
        get: function () {
            if (this._controllerWebClient === undefined) {
                this._controllerWebClient = new ControllerWebClient_1.ControllerWebClient(this.webServerBase);
            }
            return this._controllerWebClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebServerProxy.prototype, "Autocomplete", {
        get: function () {
            if (this._controllerAutocomplete === undefined) {
                this._controllerAutocomplete = new ControllerAutocomplete_1.ControllerAutocomplete(this.webServerBase);
            }
            return this._controllerAutocomplete;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebServerProxy.prototype, "Event", {
        get: function () {
            if (this._controllerEvent === undefined) {
                this._controllerEvent = new ControllerEvent_1.ControllerEvent(this.webServerBase);
            }
            return this._controllerEvent;
        },
        enumerable: true,
        configurable: true
    });
    return WebServerProxy;
}());
exports.WebServerProxy = WebServerProxy;
//# sourceMappingURL=WebServerProxy.js.map